import { faCalendarTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { faHeadphones } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import moment, { type Moment } from "moment";

import store from "~/lib/store";
import type { Calendar } from "~/nav/panels/Meetings";

export const PAGE_SIZE = 10;
export const VIEW_MODE_KEY = "viewMode";

const VIEW_MODES = ["day", "agenda"] as const;
export type ViewMode = (typeof VIEW_MODES)[number];

export function isViewMode(maybeViewMode: unknown): maybeViewMode is ViewMode {
	return typeof maybeViewMode === "string" && (VIEW_MODES as readonly string[]).includes(maybeViewMode);
}

export const meetingsStore = store.namespace("meetings");

export function getActiveCalendar(calendars: Calendar[]) {
	if (calendars.length === 0) {
		return null;
	}

	const googleCalendar = calendars.find(c => c?.source === "google");
	const officeCalendar = calendars.find(c => c?.source === "office365");
	return googleCalendar || officeCalendar || calendars[0];
}

export function generateDurations(start: Moment): number[] {
	let result: number[] = [];

	const dayEnd = moment(start).startOf("day").add(1, "day");
	for (
		let current = 0.25;
		current <= moment.duration(dayEnd.diff(start)).asHours();
		current = current >= 1 ? current + 0.5 : current + 0.25
	) {
		result.push(current);
	}

	return result;
}

export const timeBlockTypeIcons = {
	focusTime: faHeadphones,
	outOfOffice: faCalendarTimes,
};
